
import React, { useState } from "react";
import { Box, Menu, MenuItem, Typography, Dialog, DialogTitle, DialogContent, DialogActions, alpha, Avatar } from "@mui/material";
import ButtonComponent from "src/components/shared/Button";
import theme from "src/config/theme";
import { CardContainer, CardHeader, InnerContainer, ProfileContainer, Title, Year_Gender, Title2, Dot, Line, InnerContainer2, Title3, SymptomsContainer, SymptomsText, CheapContainer, MenuContainer, AvatarIcon, PatientCardContainer, RoleContainer, PagingContainer, Container2, InnerAppointments, InnerBox } from "./Style";
import { ReactComponent as More } from '../../../../assets/images/more.svg';
import { ReactComponent as Profile } from '../../../../assets/images/profile-circle.svg';
import { ReactComponent as ArrowRight } from '../../../../assets/images/arrow-right 2.svg';
import { ReactComponent as Close } from '../../../../assets/images/close-circle.svg';
import Paging from "src/components/App/Paging";

import { useNavigate } from 'react-router-dom';


const BillingCard = ({ data, page, perPage, setPage, totalCount }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();

    const handleMenuOpen = (event, item) => {
        setAnchorEl(event.currentTarget);
        setSelectedRow(item);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
        setSelectedRow(null);
    };
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const actions = [
        // { label: "View Profile", icon: <Profile />, onClick: () => navigate("/appointment/Patients") },
        // { label: "Attend Now", icon: <ArrowRight />, onClick: () => navigate("/Patients") },
        { label: "Cancel", icon: <Close />, onClick: () => handleOpen() }
    ];
    return (
        <Container2>
            <InnerAppointments>
                <InnerBox isEmpty={data.length === 0}>
                    {data.map((item, index) => {
                        return (
                            <PatientCardContainer key={index}>
                                <CardHeader sx={{ [theme.breakpoints.down('md')]: { padding: '0 20px' } }}>
                                    <InnerContainer sx={{ [theme.breakpoints.down('md')]: { height: '65px' } }}>
                                        <Title>{item.paymentfor}</Title>
                                        <Year_Gender>
                                            <Title2 sx={{ fontWeight: 'bold' }}>Amount : </Title2>
                                            <Title2>{item.amount}</Title2>
                                        </Year_Gender>
                                        <Year_Gender>
                                            <Title2>{item.paymenttype}</Title2>
                                            <Dot />
                                            <Title2>{item.paymentmethod}</Title2>
                                        </Year_Gender>
                                    </InnerContainer>
                                </CardHeader>
                                <Line />
                                <InnerContainer2 sx={{ [theme.breakpoints.down('md')]: { padding: '0 20px', justifyContent: 'space-between' } }}>
                                    <RoleContainer label={item.addedDate}>
                                    </RoleContainer>
                                    <MenuContainer
                                        onClick={(event) => handleMenuOpen(event, item)}
                                        isActive={selectedRow === item}
                                        disabled={true}
                                    >
                                        <More />
                                    </MenuContainer>
                                </InnerContainer2>
                                <Menu
                                    anchorEl={anchorEl}
                                    open={Boolean(anchorEl)}
                                    onClose={handleMenuClose}
                                    sx={{
                                        "& .MuiPaper-root": {
                                            width: "176px",
                                            borderRadius: "12px",
                                            padding: "4px 18px",
                                            backgroundColor: "red",
                                            border: `1px solid ${alpha(theme.palette.gery.black, 0.1)}`,
                                            backgroundColor: theme.palette.gery.white,
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            gap: '14px',
                                        }
                                    }}
                                >
                                    {actions.map((action, index) => (
                                        <MenuItem key={index} onClick={() => {
                                            action.onClick(selectedRow);
                                            handleMenuClose();
                                        }}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                {action.icon} <Typography>{action.label}</Typography>
                                            </Box>
                                        </MenuItem>
                                    ))}
                                </Menu>
                            </PatientCardContainer>
                        );
                    })}
                </InnerBox>
                <PagingContainer>
                    <Paging
                        page={page}
                        perPage={perPage}
                        count={totalCount || 0}
                        onChange={(newPage) => setPage(newPage)}
                    />
                </PagingContainer>
            </InnerAppointments>
        </Container2>
    );
};

export default BillingCard;

